import React, { useContext } from 'react';
import { TablePagination } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import AdminNav from './adminNav';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import noData from './no-data.png'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { userContext } from '../../contexts/userContext';
import './admin.css';



import { useEffect, useState } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { FormControl, InputLabel, MenuItem, Select, Checkbox } from '@mui/material';



export default function BasicCard() {
  const navigate = useNavigate();
  const { userId,userType } = useContext(userContext);
  const [rows, setRows] = useState([])
  const [id, setId] = useState('')
  const [message, setMessage] = useState('')
  const [deleteId, setDeleteId] = useState('')
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = useState('')
  const [selectedId, setSelectedId] = useState(userId)
  const [users, setUsers] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkExpiredAt, setBulkExpiredAt] = useState('');

  function bulkSetExpiredAt(expiredAt) {
    const token = localStorage.getItem("auth-token");
    axios.post(`/bulk_Order_expiredAt`, { ids: selectedRows, expiredAt }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        setSelectedRows([])
        setBulkExpiredAt('')
        getBasicCards()
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const toggleRow = (rowId) => {
    setSelectedRows(prev => prev.includes(rowId) ? prev.filter(i => i !== rowId) : [...prev, rowId]);
  };
  const allSelected = rows.length > 0 && rows.every(r => selectedRows.includes(r._id));
  const toggleAll = () => {
    setSelectedRows(allSelected ? [] : rows.map(r => r._id));
  };
  function bulkSetOrderEnabled(orderEnabled) {
    const token = localStorage.getItem("auth-token");
    axios.post(`/bulk_Order_enabled`, { ids: selectedRows, orderEnabled }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        setSelectedRows([])
        getBasicCards()
      })
      .catch((err) => {
        console.error(err);
      });
  }
  // console.log("console.log('userType',userType);",userType);
  function getAllUsers(params) {
    const token = localStorage.getItem("auth-token");
    axios
      .post(`/getUsers`, {
        type: '1'
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then((result) => {
        console.log('result', result);
        setUsers(result.data.Users)
      })
      .catch((err) => {
        // setMessage("No Category found")
      });
  }
  useEffect(() => {
    getAllUsers()
  }, [])

  const handleClickOpen = (id) => {
    setOpen(true);
    setDeleteId(id)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteItemById = (id) => {
    axios.post(`/delete_Order`, { id: deleteId })
      .then((result) => {
        getBasicCards()
        setId(deleteId)
        handleClose()
      })
      .catch(() => {
        setMessage("No item found")
      });
  }
  function getBasicCards() {
    const token = localStorage.getItem("auth-token");
    axios
      .post(`get_Order_by_status`, {
        type: '1',
        search: search,
        selectedUser: selectedId,
        page: page + 1, // MUI pages start at 0, API at 1
        limit: rowsPerPage
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then((result) => {
        setRows(result.data.foundedData);
        setTotalItems(result.data.pagination.totalItems);
      })
      .catch((err) => {
        setMessage("No Category found");
      });
  }

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  // function getBasicCards(params) {
  //   axios
  //     .post(`get_Order_by_status`, {
  //       type: '1',
  //       search: search,
  //       selectedUser: selectedId
  //     })
  //     .then((result) => {
  //       console.log('result2345678', result.data.foundedData);
  //       setRows(result.data.foundedData.reverse())
  //       // setMessage("result")
  //     })
  //     .catch((err) => {
  //       setMessage("No Category found")
  //     });
  // }
  const handleChange = (event) => {
    setSearch(event.target.value);
  };
  useEffect(() => {
    setSelectedRows([])
    getBasicCards()
  }, [page, rowsPerPage, search, selectedId]);
  return (
    <>
      <AdminNav />
      <Container className='' maxWidth="xl">
        <div className='title-with-search'>
          <h2>Basic Cards</h2>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            {userType == 1 && <FormControl fullWidth className='select-type-menu new-seelect-user'>
              <InputLabel id="user-select-label">Select User</InputLabel>
              <Select
                labelId="user-select-label"
                id="user-select"
                value={selectedId}
                label="Select User"
                onChange={(e) => setSelectedId(e.target.value)}
              >
                <MenuItem value="">all</MenuItem>
                {users.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.userName} - {user.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
            <TextField id="outlined-basic" label="Enter name" variant="outlined" value={search}
              onChange={handleChange} />
          </div>

        </div>
        {rows.length == 0 ?
          <div className='image-no-data-div'>
            <img src={noData} alt="noData image" />
          </div>
          :
          <>
            {userType == 1 && selectedRows.length > 0 &&
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                <span>{selectedRows.length} selected</span>
                <Button variant="contained" color="success" onClick={() => bulkSetOrderEnabled(true)}>Set Active</Button>
                <Button variant="contained" color="error" onClick={() => bulkSetOrderEnabled(false)}>Set Expired</Button>
                <TextField
                  type="date"
                  size="small"
                  label="End date"
                  value={bulkExpiredAt}
                  onChange={(e) => setBulkExpiredAt(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: '9999-12-31' }}
                />
                <Button variant="contained" disabled={!bulkExpiredAt} onClick={() => bulkSetExpiredAt(bulkExpiredAt)}>Set End Date</Button>
                <Button variant="outlined" onClick={() => bulkSetExpiredAt(null)}>Clear End Date</Button>
              </div>}

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {userType == 1 && <TableCell padding="checkbox">
                      <Checkbox
                        checked={allSelected}
                        indeterminate={selectedRows.length > 0 && !allSelected}
                        onChange={toggleAll}
                      />
                    </TableCell>}
                    <TableCell >Name</TableCell>
                    {/* <TableCell >Company</TableCell> */}
                    <TableCell >phone</TableCell>
                    {/* <TableCell >Image</TableCell> */}
                    <TableCell >Created at</TableCell>
                    <TableCell >End date</TableCell>
                    <TableCell >Status</TableCell>
                    <TableCell >Link</TableCell>
                    <TableCell >QR Code</TableCell>
                    <TableCell >Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      {userType == 1 && <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(row._id)}
                          onChange={() => toggleRow(row._id)}
                        />
                      </TableCell>}
                      <TableCell >{row.fullName}</TableCell>
                      {/* <TableCell>{row.company == '' ? '-' : row.company}</TableCell> */}
                      <TableCell>{row?.mobileNumber?.length > 0 ? row?.mobileNumber[0].link : '-'}</TableCell>
                      {/* <TableCell><img className='order-pending-image' src={row.mainUserImg} /></TableCell> */}
                      <TableCell>{row.createdAt}</TableCell>
                      <TableCell style={{color: row.expiredAt && row.expiredAt < new Date().toISOString().split('T')[0] ? 'red' : 'green'}}>{row.expiredAt ? row.expiredAt : '-'}</TableCell>
                      <TableCell style={{color: row.orderEnabled ? 'green' : 'red'}}>{row.orderEnabled ? 'Active' : 'Expired'}</TableCell>
                      <TableCell>{row.cardLink}</TableCell>
                      <TableCell>{row.qr ? row.qr : '-'}</TableCell>
                      <TableCell >
                        <div style={{ display: 'flex' }}>
                          <DeleteIcon onClick={() => handleClickOpen(row._id)} className='cancel-icon' />
                          <EditIcon className='edit-icon' onClick={() => navigate(`/EditOrder?id=${row._id}`)()} />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

            </TableContainer></>
        }
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm to delete"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>No</Button>
            <Button onClick={() => deleteItemById()} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
      </Container>
      
    </>
  );
}